module.exports = __webpack_public_path__ + "img/members of the yakumo family.4f027ab1.png";